import {
  deleteFundingReport,
  OPEN_DELETE_FUNDING_REPORT_MODAL,
  CLOSE_DELETE_FUNDING_REPORT_MODAL,
} from './types';

export * from './actions';

const deleteFundingReportReducerObject = {
  [deleteFundingReport.failure]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['deleteFundingReport', 'network', 'error'], true)
        .setIn(['deleteFundingReport', 'network', 'loading'], false)
        .setIn(['deleteFundingReport', 'network', 'success'], false),
    ),
  [deleteFundingReport.request]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['deleteFundingReport', 'network', 'error'], false)
        .setIn(['deleteFundingReport', 'network', 'loading'], true),
    ),
  [deleteFundingReport.success]: (state, { reportId }) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(
          ['all', 'ids'],
          currentState.getIn(['all', 'ids']).filter((key) => key !== reportId),
        )
        .setIn(['deleteFundingReport', 'modalOpen'], false)
        .setIn(['deleteFundingReport', 'network', 'loading'], false)
        .setIn(['deleteFundingReport', 'network', 'success'], true),
    ),

  [OPEN_DELETE_FUNDING_REPORT_MODAL]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['deleteFundingReport', 'modalOpen'], true)
        .setIn(['deleteFundingReport', 'fundingReport'], action.fundingReport),
    ),
  [CLOSE_DELETE_FUNDING_REPORT_MODAL]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['deleteFundingReport', 'modalOpen'], false)
        .setIn(['deleteFundingReport', 'fundingReport'], false),
    ),
};

export default deleteFundingReportReducerObject;
